/*
* @Author: rkm
* @title:  富文本编辑器配置
* @Date:   2019-08-05 16:02:15
* @Last Modified by:   rkm
* @Last Modified time: 2019-08-05 16:02:15
*/

export const editorOption = {
  placeholder: '请编辑文章',
  modules: {
    // imageDrop: true,
    // imageResize: true,
    // 工具栏
    // toolbar: '#toolbar',
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction
        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        [{ 'font': [] }],
        [{ 'align': [] }],
        ['clean'],                                        // remove formatting button
        ['image'],
      ],
      handlers: {

      },
    },
    
  },
}
